import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'
import { Id } from '@/infra/id'

export interface AvailableInventoryItemTaxExtensionFlows {
  personalExtensionProgressionFlowAvailable: boolean
  businessExtensionProgressionFlowAvailable: boolean
  outsourcingExtensionProgressionFlowAvailable: boolean
}

export type AvailableJobProgressionFlowsProps =
  ModelProps<AvailableJobProgressionFlows>

export class AvailableJobProgressionFlows extends Model<AvailableJobProgressionFlows> {
  jobId = Id.none

  @observable
  accessor availableInventoryItemTaxExtensionFlows: AvailableInventoryItemTaxExtensionFlows | null =
    null
}
